<template>
  <div>
    <v-row justify="space-between">
      <v-col
        cols="12"
        md="5">
        <v-row>
          <v-col cols="12">
            <h1 class="title font-weight-bold">
              รายการสินค้า
            </h1>
          </v-col>
        </v-row>
        <v-row class="cart-items">
          <v-col
            v-for="(item, index) in items"
            :key="`itemInCart-${index}`"
            class="cart-single-item"
            cols="12">
            <div class="d-flex align-center">
              <v-checkbox
                v-if="bill.status !== 'paid' && !isExpire"
                v-model="selected"
                :value="item" />
              <h3 class="mb-0 ml-3">
                {{ item.productName }} ({{ getCampWareHouse(item.warehouse) }})
              </h3>
            </div>
            <div class="item-sku-detail pl-4">
              <p>{{ item.id }}</p>
              <p>ID: {{ item.codeTemp }}</p>
              <div class="sku-variant d-flex">
                <p
                  v-for="i in 2"
                  :key="i">
                  {{ item[`variant${i}`] }}: {{ item.concatOptions.split(' ')[i-1] }}
                </p>
              </div>
              <p class="font-weight-bold">
                {{ item.price | showFullPriceFormat() }} THB
              </p>
            </div>
            <v-btn
              v-if="cartPage || editPage"
              class="remove-btn"
              icon
              large>
              <v-icon>
                mdi-trash-can-outline
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row class="order-summary">
          <v-col cols="12">
            <h1 class="title font-weight-bold">
              สรุปคำสั่งซื้อ
            </h1>
          </v-col>
          <v-col cols="12">
            <v-row no-gutters>
              <v-col cols="4">
                <label class="pl-4 pt-2 d-block">
                  ค่าจัดส่ง
                </label>
              </v-col>
              <v-col cols="8">
                <v-text-field
                  v-if="editPage"
                  v-model="bill.shippingPrice"
                  single-line
                  dense
                  outlined
                  suffix="บาท" />
                <label
                  v-else
                  class="pl-4 pt-2 d-block">
                  {{ bill.shippingPrice | showFullPriceFormat() }} บาท
                </label>
              </v-col>
              <v-col cols="4">
                <div
                  v-if="cartPage || editPage"
                  class="pr-10 pl-4">
                  <v-select
                    :items="selectItem"
                    dense
                    outlined />
                </div>
                <label
                  v-else
                  class="pl-4 pt-2 d-block">
                  ส่วนลด
                </label>
              </v-col>
              <v-col cols="8">
                <v-text-field
                  v-if="editPage"
                  v-model="bill.discount"
                  single-line
                  dense
                  outlined
                  :suffix="cartPage || editPage ? '' : 'บาท'" />
                <label
                  v-else
                  class="pl-4 pt-2 d-block">
                  {{ bill.discount | showFullPriceFormat() }} บาท
                </label>
              </v-col>
              <v-col cols="4">
                <label class="pl-4 pt-2 d-block font-weight-bold">
                  ยอดสุทธิ
                </label>
              </v-col>
              <v-col cols="8">
                <label class="pl-4 pt-2 d-block">
                  {{ bill.net | showFullPriceFormat() }} บาท
                </label>
              </v-col>
              <v-col
                cols="12"
                class="pa-5 d-flex justify-center">
                <v-btn
                  v-if="bill.status !== 'shipped'"
                  :disabled="!(selected.length > 0)"
                  @click="dialogSms = true">
                  แจ้งรายการ
                </v-btn>
              </v-col>
              <v-col cols="12">
                <label class="pl-4 pt-2 d-block">
                  *NOTE
                </label>
                <p
                  class="pl-4 pt-2 d-block"
                  style="white-space: pre-line;">
                  {{ bill.note }}
                </p>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <v-col
        cols="12"
        md="6">
        <v-row class="order-customer">
          <v-col cols="12">
            <h1 class="title font-weight-bold">
              ข้อมูลลูกค้า
            </h1>
          </v-col>
          <v-col cols="12">
            <v-row no-gutters>
              <v-col cols="4">
                <label class="pl-4 pt-2 d-block">
                  ชื่อและนามสกุล
                </label>
              </v-col>
              <v-col cols="8">
                <v-text-field
                  v-if="editPage"
                  v-model="customer.name"
                  single-line
                  dense
                  outlined />
                <label
                  v-else
                  class="pl-4 pt-2 d-block">
                  {{ customer.name }}
                </label>
              </v-col>
              <v-col cols="4">
                <label class="pl-4 pt-2 d-block">
                  เบอร์ติดต่อ
                </label>
              </v-col>
              <v-col cols="8">
                <v-text-field
                  v-if="editPage"
                  v-model="customer.tel"
                  single-line
                  dense
                  outlined />
                <label
                  v-else
                  class="pl-4 pt-2 d-block">
                  {{ customer.tel }}
                </label>
              </v-col>
              <v-col cols="4">
                <label class="pl-4 pt-2 d-block">
                  ที่อยู่
                </label>
              </v-col>
              <v-col cols="8">
                <v-text-field
                  v-if="editPage"
                  v-model="customer.address"
                  single-line
                  dense
                  outlined />
                <label
                  v-else
                  class="pl-4 pt-2 d-block">
                  {{ customer.address }}
                </label>
              </v-col>
              <v-col cols="4">
                <label class="pl-4 pt-2 d-block">
                  ตำบล
                </label>
              </v-col>
              <v-col cols="8">
                <v-text-field
                  v-if="editPage"
                  v-model="customer.subDistrict"
                  single-line
                  dense
                  outlined />
                <label
                  v-else
                  class="pl-4 pt-2 d-block">
                  {{ customer.subDistrict }}
                </label>
              </v-col>
              <v-col cols="4">
                <label class="pl-4 pt-2 d-block">
                  อำเภอ
                </label>
              </v-col>
              <v-col cols="8">
                <v-text-field
                  v-if="editPage"
                  v-model="customer.district"
                  single-line
                  dense
                  outlined />
                <label
                  v-else
                  class="pl-4 pt-2 d-block">
                  {{ customer.district }}
                </label>
              </v-col>
              <v-col cols="4">
                <label class="pl-4 pt-2 d-block">
                  จังหวัด
                </label>
              </v-col>
              <v-col cols="8">
                <v-text-field
                  v-if="editPage"
                  v-model="customer.province"
                  single-line
                  dense
                  outlined />
                <label
                  v-else
                  class="pl-4 pt-2 d-block">
                  {{ customer.province }}
                </label>
              </v-col>
              <v-col cols="4">
                <label class="pl-4 pt-2 d-block">
                  รหัสไปรษณีย์
                </label>
              </v-col>
              <v-col cols="8">
                <v-text-field
                  v-if="editPage"
                  v-model="customer.postcode"
                  single-line
                  dense
                  outlined />
                <label
                  v-else
                  class="pl-4 pt-2 d-block">
                  {{ customer.postcode }}
                </label>
              </v-col>
            </v-row>
          </v-col>
          <v-col
            cols="12"
            class="action-row">
            <div
              class="text-right">
              <a
                class="print-btn"
                :href="`/print/${bill.id}`"
                target="_blank">
                <v-btn>
                  พิมพ์ใบแปะกล่อง
                </v-btn>
              </a>
            </div>
          </v-col>
          <v-col
            cols="12"
            class="action-row">
            <div
              class="text-right">
              <v-btn
                v-if="bill.status !== 'paid'"
                @click="dialogTracking = true">
                จัดส่งแล้ว
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-dialog
      v-model="dialogSms"
      max-width="540">
      <v-card>
        <v-card-title class="headline">
          ข้อความแจ้งแบรนด์ : {{ brand.name }} ({{ brand.phone1 }})
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col cols="12">
              Order ID : {{ bill.id }}
            </v-col>
            <v-col cols="12">
              รายการสินค้าที่ไม่มี :
            </v-col>
            <v-col cols="12">
              <v-row
                v-for="(item, index) in selected"
                :key="`selected-${index}`">
                <v-col
                  cols="5">
                  <b>{{ item.code }}</b>
                  {{ item.concatOptions }}
                </v-col>
                <v-col cols="7">
                  <v-select
                    v-model="smsText[item.billProductSkuId]"
                    :items="notes"
                    label="ระบุเหตุผล"
                    outlined />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="closeDialog()">
            ยกเลิก
          </v-btn>

          <v-btn
            color="green darken-1"
            text
            :disabled="disableConfirm"
            @click="editBill()">
            ยืนยัน
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogTracking"
      max-width="540">
      <v-card>
        <v-card-title class="headline">
          กรุณาใส่เลข Tracking
        </v-card-title>

        <v-card-text>
          <v-text-field
            v-model="tracking"
            label="ระบุ Tracking Number"
            single-line
            outlined />
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="closeDialog()">
            ยกเลิก
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            :disabled="tracking === ''"
            @click="sendTrackingNumber()">
            ยืนยัน
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    items: {
      type: Array,
      required: true,
      default: () => []
    },
    cartPage: {
      type: Boolean,
      required: false,
      default: false
    },
    customer: {
      type: Object,
      required: false,
      default: () => {}
    },
    bill: {
      type: Object,
      required: false,
      default: () => {}
    },
    brand: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  data () {
    return {
      notes: [
        'สินค้ามี Deflect',
        'สินค้าถูกขายหน้าร้าน',
        'อื่นๆ'
      ],
      editPage: false,
      selectItem: [
        '%',
        'บาท'
      ],
      selected: [],
      dialogSms: false,
      dialogTracking: false,
      smsText: {},
      tracking: ''
    }
  },
  computed: {
    ...mapGetters({
      warehouse: 'Warehouse/warehouse'
    }),
    disableConfirm () {
      const keys = Object.keys(this.smsText)
      return this.selected.length !== keys.length
    },
    isExpire () {
      let expired = false
      if (this.bill.status === 'confirmed') {
        const now = this.$dayjs()
        const billExpire = this.$dayjs(this.bill.expire)

        expired = now - billExpire > 0
      }

      return expired
    }
  },
  mounted () {
    if (this.cartPage) {
      this.editPage = true
    }
  },
  methods: {
    closeDialog () {
      this.smsText = {}
      this.dialogSms = false
      this.tracking = ''
      this.dialogTracking = false
    },
    editBill () {
      let message = `ออเดอร์ : ${this.bill.id} ไม่สามารถจัดส่งได้เนื่องจาก`
      Object.keys(this.smsText).forEach((key) => {
        if (this.smsText[key] !== '') {
          const item = this.items.find((r) => r.billProductSkuId === key)
          message += `\n${item.code} : ${this.smsText[key]}`
        }
      })
      message += '\nกรุณาแก้ไขรายการสินค้าที่หน้ารายการออเดอร์'
      this.dialogSms = false
      this.$emit('editNote', message)
      this.smsText = {}
    },
    sendTrackingNumber () {
      this.$emit('trackingNumber', this.tracking)
      this.tracking = ''
      this.dialogTracking = false
    },
    getCampWareHouse (skuWarehouse) {
      const result = this.warehouse.find((warehouse) => warehouse.sellsukiWarehouse === skuWarehouse)
      return result !== {} ? result.campWarehouse : 'unknown'
    }
  }
}
</script>

<style scoped>
.sku-variant.d-flex> p:first-child {
  min-width: 75px;
  margin-right: 10px;
}
.cart-single-item {
  position: relative;
  border-bottom: 1px solid #c4c4c4;
  margin-bottom: 16px;
}
.add-new-item,
.order-summary,
.order-customer {
  border-bottom: 1px solid #c4c4c4;
  padding-bottom: 16px;
  margin-bottom: 16px;
}
button.remove-btn {
  position: absolute;
  bottom: 30px;
  right: 30px;
  transition: all 0.1s;
}
button.remove-btn:active {
  transform: scale(1.2);
}
a.print-btn {
  color: #000;
  text-decoration: unset;
}
.back-btn {
  position: absolute;
  top: 95%;
  left: -10px;
}
</style>
